(function () {
  'use strict';

  angular
    .module('app.page-user-certificates', []);
})();
